import React from 'react';
import { Route, Routes } from 'react-router-dom';

import AppNavigate from '../../components/reusable/app-navigate/AppNavigate';
import { Paths } from '../../shared/paths';
import Programs from './Programs';
import NewProgramCollection from './edit-program-collection/EditProgramCollection';
import EditProgramItem from './edit-program-item/EditProgramItem';
import EditProgramSet from './edit-program-set/EditProgramSet';
import ProgramCollection from './program-collection/ProgramCollection';
import ViewProgramItem from './view-program-item/ViewProgramItem';
import ViewProgramSet from './view-program-set/ViewProgramSet';

export default function ProgramsRouter() {
  return (
    <Routes>
      <Route path={`${Paths.programs.list}/*`} element={<Programs />} />

      <Route
        path={`${Paths.programs.collection}${Paths.programs.new}`}
        element={<NewProgramCollection />}
      />
      <Route
        path={`${Paths.programs.collection}/:programId${Paths.programs.edit}`}
        element={<NewProgramCollection />}
      />
      <Route
        path={`${Paths.programs.collection}/:programId${Paths.programs.view}/*`}
        element={<ProgramCollection />}
      />
      <Route
        path={`${Paths.programs.item}${Paths.programs.new}`}
        element={<EditProgramItem />}
      />
      <Route
        path={`${Paths.programs.item}/:programItemId${Paths.programs.edit}`}
        element={<EditProgramItem />}
      />
      <Route
        path={`${Paths.programs.item}/:programItemId${Paths.programs.view}/*`}
        element={<ViewProgramItem />}
      />
      <Route
        path={`${Paths.programs.set}${Paths.programs.new}`}
        element={<EditProgramSet />}
      />
      <Route
        path={`${Paths.programs.set}/:setId${Paths.programs.edit}`}
        element={<EditProgramSet />}
      />
      <Route
        path={`${Paths.programs.set}/:setId${Paths.programs.view}`}
        element={<ViewProgramSet />}
      />
      <Route
        path={'*'}
        element={<AppNavigate to={Paths.programs.toList} replace />}
      />
    </Routes>
  );
}
